/**
 * Dismiss the Zoraxy loading screen as soon as the first visible conversation
 * list settles. Counters, menu metadata and secondary tabs enrich an already
 * interactive screen and must not hold the whole application hostage.
 */
export const waitForZoraxyCriticalData = ({
  conversations,
  stats,
  menuData,
  secondaryTabs,
}) => {
  [stats, menuData, secondaryTabs].forEach(request => {
    Promise.resolve(request).catch(() => null);
  });

  return Promise.allSettled([conversations]);
};
